<template>
  <td :style="getStyleCell(value, percent)">
    {{ percent }}
  </td>
</template>
<script>
import MixinMasters from 'src/util/mixinMasters';

export default {
  name: 'percent-cell-balance',
  props: {
    value: {
      type: Number | String,
      default: 0,
    },
    percent: {
      type: String,
      default: 0,
    },
  },
  mixins: [MixinMasters],
  methods: {
    getStyleCell(value, percent) {
      const p = Number(percent.replace('%', ''));
      const v = Number(value.replaceAll(',', ''));
      if (v == 0)
        return 'background-color: #6BA652; color:white; text-align: center';
      if (v < 0)
        return 'background-color: #FB404B; color:white; text-align: center';
      if (p >= 95)
        return 'background-color: #409eff; color:white; text-align: center';
      if (p < 95)
        return 'background-color: yellow; color:black; text-align: center';
    },
  },
};
</script>
